import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import type { Control, FieldValues } from 'react-hook-form';

import { PhoneInputField } from '@/components/common/PhoneInputField';
import { CanalEnvio } from '@/types/enums';
import { CANAL_ENVIO_LABELS } from '@/utils/labels';

interface FacturacionSectionProps {
  register: (name: string) => Record<string, unknown>;
  errors: Record<string, { message?: string } | undefined>;
  control: Control<FieldValues>;
}

export function FacturacionSection({
  register,
  errors,
  control,
}: FacturacionSectionProps): JSX.Element {
  return (
    <Accordion
      variant="outlined"
      sx={{ borderRadius: 1, '&:before': { display: 'none' } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Datos de facturación
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ ml: 2, alignSelf: 'center' }}
        >
          Opcional
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              label="CUIT"
              fullWidth
              {...register('facturacion.cuit')}
              error={!!errors['facturacion.cuit']}
              helperText={errors['facturacion.cuit']?.message ?? ' '}
            />
            <TextField
              label="Razón social"
              fullWidth
              {...register('facturacion.razon_social')}
              error={!!errors['facturacion.razon_social']}
              helperText={errors['facturacion.razon_social']?.message ?? ' '}
            />
          </Stack>

          <TextField
            label="Email para facturación"
            fullWidth
            type="email"
            {...register('facturacion.email_facturacion')}
            error={!!errors['facturacion.email_facturacion']}
            helperText={errors['facturacion.email_facturacion']?.message ?? ' '}
          />

          <PhoneInputField
            control={control}
            name={'facturacion.telefono_whatsapp_facturacion' as never}
            label="Teléfono / WhatsApp para facturación"
          />

          <TextField
            select
            label="Canal de envío de factura"
            fullWidth
            defaultValue=""
            {...register('facturacion.envio_factura')}
            error={!!errors['facturacion.envio_factura']}
            helperText={errors['facturacion.envio_factura']?.message ?? ' '}
          >
            <MenuItem value="">— Sin definir —</MenuItem>
            {Object.values(CanalEnvio).map((value) => (
              <MenuItem key={value} value={value}>
                {CANAL_ENVIO_LABELS[value]}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
